import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
} from '../shared/schema'

// this is the dart definition
// required double cameraOffTime,
// required double durationPresent,
// required String roomId,
// required double totalTalkTime,
// required double totalTime,
// required String userId,
// required double userTalkTime,
// String assignmentId,
// String sectionId,
// int? updatedAt,
export const schema = z.object({
  // failing on fake AI
  cameraOffTime: nullSafeOptionalNumber(),
  // failing on fake AI
  durationPresent: nullSafeOptionalNumber(),
  roomId: z.string(),
  totalChatCount: nullSafeOptionalNumber(),
  // failing on fake AI
  totalTalkTime: nullSafeOptionalNumber(),
  // failing on fake AI
  totalTime: nullSafeOptionalNumber(),
  userId: z.string(),
  userChatCount: nullSafeOptionalNumber(),
  // failing on fake AI
  userTalkTime: nullSafeOptionalNumber(),
  // true once the participant published video at least once (any VIDEO_ON/OFF
  // event). Absent on rooms aggregated before BL-4582. Used by camera-on
  // Completion scoring to close the "never published video" loophole.
  videoPublished: nullSafeOptionalBoolean(),
  // Set by mid-session partial grading runs; the official run deletes it,
  // so official and historical docs never carry it.
  partial: nullSafeOptionalBoolean(),
  assignmentId: nullSafeOptionalString(),
  sectionId: nullSafeOptionalString(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    cameraOffTime: 0,
    durationPresent: 0,
    roomId: '',
    totalTalkTime: 0,
    totalTime: 0,
    userId: '',
    userTalkTime: 0,
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

type FirestoreRoomStateEngagementInferred = z.infer<typeof schema>
export type FirestoreRoomStateEngagement = FirestoreRoomStateEngagementInferred
export type FirestoreRoomStateEngagementWrite = z.infer<typeof schema>
